import type { CommunicationLanguage, UserPreferenceResponse } from '@/shared/models/user-preference.model';
import { userPreferenceApi } from '@/shared/services/apis/user-preference-api.service';

export async function fetchMyPreferences(): Promise<UserPreferenceResponse[] | null> {
  try {
    const response = await userPreferenceApi.getMyPreference();
    if (response.ok && response.data) {
      return response.data.data ?? null;
    }
    console.warn('[user-preference] GET preference/me failed:', response.problem);
    return null;
  } catch (error) {
    console.warn('[user-preference] GET preference/me error:', error);
    return null;
  }
}

export async function updateMyPreference(
  language: CommunicationLanguage
): Promise<boolean> {
  try {
    const response = await userPreferenceApi.updateMyPreference(language);
    return response.ok === true;
  } catch (error) {
    console.warn('[user-preference] PUT preference/me error:', error);
    return false;
  }
}
